import React, { useState } from "react";

export function DownloadOutlineIcon({}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1251 6.875H14.6876C15.102 6.875 15.4994 7.03962 15.7925 7.33265C16.0855 7.62567 16.2501 8.0231 16.2501 8.4375V16.5625C16.2501 16.9769 16.0855 17.3743 15.7925 17.6674C15.4994 17.9604 15.102 18.125 14.6876 18.125H5.31262C4.89822 18.125 4.50079 17.9604 4.20777 17.6674C3.91474 17.3743 3.75012 16.9769 3.75012 16.5625V8.4375C3.75012 8.0231 3.91474 7.62567 4.20777 7.33265C4.50079 7.03962 4.89822 6.875 5.31262 6.875H6.87512"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 10.625L10 13.75L13.125 10.625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1.875V13.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CreatePageIcon({}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7H9V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V7H1C0.734784 7 0.48043 7.10536 0.292893 7.29289C0.105357 7.48043 0 7.73478 0 8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H7V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V9H15C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8C16 7.73478 15.8946 7.48043 15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MenuIcons(props) {
  return (
    <svg {...props} width="28" height="28" fill="#fff" viewBox="0 0 24 24">
      <path d="M6,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM16,6c0,1.1 0.9,2 2,2s2,-0.9 2,-2 -0.9,-2 -2,-2 -2,0.9 -2,2zM12,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2z"></path>
    </svg>
  );
}

export function InvexCheckCircle(props) {
  return (
    <svg
      {...props}
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11.08V12C20.9988 14.1564 20.3005 16.2547 19.0093 17.9818C17.7182 19.709 15.9033 20.9725 13.8354 21.5839C11.7674 22.1953 9.55726 22.1219 7.53447 21.3746C5.51168 20.6273 3.78465 19.2461 2.61096 17.4371C1.43727 15.628 0.879791 13.4881 1.02168 11.3363C1.16356 9.18455 1.99721 7.13631 3.39828 5.49706C4.79935 3.85781 6.69279 2.71537 8.79619 2.24013C10.8996 1.7649 13.1003 1.98232 15.07 2.85999M21 3.99999L11 14.01L8.00001 11.01"
        stroke="#101828"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function InvexFavouriteChart(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V13C22.75 13.41 22.41 13.75 22 13.75C21.59 13.75 21.25 13.41 21.25 13V9C21.25 4.39 19.61 2.75 15 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H13C13.41 21.25 13.75 21.59 13.75 22C13.75 22.41 13.41 22.75 13 22.75Z"
        fill="#292D32"
      />
      <path
        d="M7.33009 15.24C7.17009 15.24 7.0101 15.19 6.8701 15.08C6.5401 14.83 6.48012 14.36 6.73012 14.03L9.11009 10.94C9.40009 10.57 9.81011 10.33 10.2801 10.27C10.7501 10.21 11.2101 10.34 11.5801 10.63L13.4101 12.07C13.4801 12.13 13.5501 12.12 13.6001 12.12C13.6401 12.12 13.7101 12.1 13.7701 12.02L16.0801 9.04C16.3301 8.71 16.8001 8.65001 17.1301 8.91001C17.4601 9.16001 17.5201 9.63001 17.2601 9.96001L14.9501 12.94C14.6601 13.31 14.2501 13.55 13.7801 13.6C13.3201 13.66 12.8501 13.53 12.4901 13.24L10.6601 11.8C10.5901 11.74 10.5101 11.74 10.4701 11.75C10.4301 11.75 10.3601 11.77 10.3001 11.85L7.92012 14.94C7.78012 15.14 7.56009 15.24 7.33009 15.24Z"
        fill="#292D32"
      />
      <path
        d="M20.26 22.75C19.91 22.75 19.46 22.64 18.93 22.32L18.68 22.17C18.61 22.13 18.3999 22.13 18.3299 22.17L18.0799 22.32C16.9299 23.01 16.2 22.72 15.88 22.48C15.55 22.24 15.04 21.64 15.34 20.32L15.39 20.11C15.41 20.03 15.3499 19.84 15.2999 19.78L14.95 19.43C14.36 18.83 14.1299 18.13 14.3299 17.5C14.5299 16.88 15.12 16.44 15.95 16.3L16.3299 16.24C16.3999 16.22 16.5399 16.12 16.5799 16.05L16.8599 15.48C17.2499 14.69 17.85 14.24 18.51 14.24C19.17 14.24 19.77 14.69 20.16 15.48L20.44 16.04C20.48 16.11 20.62 16.21 20.69 16.23L21.07 16.29C21.9 16.43 22.49 16.87 22.69 17.49C22.89 18.11 22.67 18.81 22.07 19.42L21.72 19.77C21.67 19.83 21.61 20.02 21.63 20.1L21.68 20.31C21.98 21.63 21.47 22.23 21.14 22.47C20.96 22.61 20.67 22.75 20.26 22.75ZM18.49 15.75C18.48 15.76 18.34 15.86 18.2 16.15L17.92 16.72C17.68 17.21 17.1099 17.63 16.5799 17.72L16.2 17.78C15.88 17.83 15.77 17.94 15.76 17.96C15.76 17.98 15.79 18.14 16.02 18.37L16.37 18.72C16.78 19.14 16.9899 19.86 16.8599 20.43L16.81 20.64C16.72 21.03 16.76 21.2 16.78 21.26C16.81 21.24 16.98 21.22 17.31 21.02L17.56 20.87C18.11 20.54 18.9 20.54 19.45 20.87L19.7 21.02C20.11 21.27 20.28 21.24 20.29 21.24C20.25 21.24 20.3 21.04 20.21 20.64L20.16 20.43C20.03 19.85 20.24 19.14 20.65 18.72L21 18.37C21.23 18.14 21.26 17.98 21.26 17.95C21.25 17.93 21.14 17.83 20.82 17.77L20.44 17.71C19.9 17.62 19.34 17.2 19.1 16.71L18.82 16.15C18.66 15.85 18.52 15.76 18.49 15.75Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function InvexPieChart(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.21 15.89C20.5739 17.3945 19.5788 18.7202 18.3119 19.7513C17.045 20.7824 15.5448 21.4874 13.9425 21.8048C12.3401 22.1221 10.6845 22.0421 9.12018 21.5718C7.55591 21.1014 6.13066 20.2551 4.96906 19.1067C3.80745 17.9582 2.94485 16.5428 2.45667 14.9839C1.96849 13.4251 1.8696 11.7705 2.16863 10.1646C2.46767 8.55878 3.15553 7.05063 4.17208 5.77203C5.18863 4.49343 6.50292 3.48332 8.00004 2.83M22 12C22 10.6868 21.7414 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8269 2.7612C14.6136 2.25866 13.3133 2 12 2V12H22Z"
        stroke="#101828"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function DocumentText(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill="#292D32"
      />
      <path
        d="M22 10.75H18C14.58 10.75 13.25 9.41999 13.25 5.99999V1.99999C13.25 1.69999 13.43 1.41999 13.71 1.30999C13.99 1.18999 14.31 1.25999 14.53 1.46999L22.53 9.46999C22.74 9.67999 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.80999V5.99999C14.75 8.57999 15.42 9.24999 18 9.24999H20.19L14.75 3.80999Z"
        fill="#292D32"
      />
      <path
        d="M13 13.75H7C6.59 13.75 6.25 13.41 6.25 13C6.25 12.59 6.59 12.25 7 12.25H13C13.41 12.25 13.75 12.59 13.75 13C13.75 13.41 13.41 13.75 13 13.75Z"
        fill="#292D32"
      />
      <path
        d="M11 17.75H7C6.59 17.75 6.25 17.41 6.25 17C6.25 16.59 6.59 16.25 7 16.25H11C11.41 16.25 11.75 16.59 11.75 17C11.75 17.41 11.41 17.75 11 17.75Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function InvexSendSquare(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 9.51001L12 6.51001L15 9.51001"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 6.51001V14.51"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 16.51C9.89 17.81 14.11 17.81 18 16.51"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function InvexMoneyRecieve(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.05 16.25H11.17C9.84001 16.25 8.75 15.13 8.75 13.75C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H13.05C13.44 14.75 13.75 14.4 13.75 13.97C13.75 13.43 13.6 13.35 13.26 13.23L10.25 12.18C9.61 11.96 8.75 11.49 8.75 10.02C8.75 8.76999 9.74001 7.73999 10.95 7.73999H12.83C14.16 7.73999 15.25 8.85999 15.25 10.24C15.25 10.65 14.91 10.99 14.5 10.99C14.09 10.99 13.75 10.65 13.75 10.24C13.75 9.68999 13.34 9.23999 12.83 9.23999H10.95C10.56 9.23999 10.25 9.58999 10.25 10.02C10.25 10.56 10.4 10.64 10.74 10.76L13.75 11.81C14.39 12.03 15.25 12.5 15.25 13.97C15.25 15.23 14.26 16.25 13.05 16.25Z"
        fill="#292D32"
      />
      <path
        d="M12 17.25C11.59 17.25 11.25 16.91 11.25 16.5V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V16.5C12.75 16.91 12.41 17.25 12 17.25Z"
        fill="#292D32"
      />
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2C12.75 2.41 12.41 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 11.59 21.59 11.25 22 11.25C22.41 11.25 22.75 11.59 22.75 12C22.75 17.93 17.93 22.75 12 22.75Z"
        fill="#292D32"
      />
      <path
        d="M21 7.75H17C16.59 7.75 16.25 7.41 16.25 7V3C16.25 2.59 16.59 2.25 17 2.25C17.41 2.25 17.75 2.59 17.75 3V6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
        fill="#292D32"
      />
      <path
        d="M16.9999 7.74994C16.8099 7.74994 16.6199 7.67994 16.4699 7.52994C16.1799 7.23994 16.1799 6.75994 16.4699 6.46994L21.4699 1.46994C21.7599 1.17994 22.2399 1.17994 22.5299 1.46994C22.8199 1.75994 22.8199 2.23994 22.5299 2.52994L17.5299 7.52994C17.3799 7.67994 17.1899 7.74994 16.9999 7.74994Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function InvexBox(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.3C11.87 13.3 11.74 13.27 11.62 13.2L2.78996 8.08998C2.43996 7.87998 2.30996 7.41998 2.51996 7.05998C2.72996 6.69998 3.18996 6.57998 3.54996 6.78998L12 11.68L20.4 6.81998C20.76 6.60998 21.22 6.73998 21.43 7.08998C21.64 7.44998 21.51 7.90998 21.16 8.11998L12.39 13.2C12.26 13.26 12.13 13.3 12 13.3Z"
        fill="#292D32"
      />
      <path
        d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z"
        fill="#292D32"
      />
      <path
        d="M12 22.75C11.12 22.75 10.25 22.56 9.56002 22.18L4.22001 19.21C2.77001 18.41 1.64001 16.48 1.64001 14.82V9.17C1.64001 7.51 2.77001 5.59 4.22001 4.78L9.56002 1.82C10.93 1.06 13.07 1.06 14.44 1.82L19.78 4.79C21.23 5.59 22.36 7.52 22.36 9.18V14.83C22.36 16.49 21.23 18.41 19.78 19.22L14.44 22.18C13.75 22.56 12.88 22.75 12 22.75ZM12 2.75C11.37 2.75 10.75 2.88 10.29 3.13L4.95001 6.1C3.99001 6.63 3.14001 8.07 3.14001 9.17V14.82C3.14001 15.92 3.99001 17.36 4.95001 17.9L10.29 20.87C11.2 21.38 12.8 21.38 13.71 20.87L19.05 17.9C20.01 17.36 20.86 15.93 20.86 14.82V9.17C20.86 8.07 20.01 6.63 19.05 6.09L13.71 3.12C13.25 2.88 12.63 2.75 12 2.75Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function InvexMoneyTick(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25ZM12 10.25C11.04 10.25 10.25 11.04 10.25 12C10.25 12.96 11.04 13.75 12 13.75C12.96 13.75 13.75 12.96 13.75 12C13.75 11.04 12.96 10.25 12 10.25Z"
        fill="currentColor"
      />
      <path
        d="M18.5 15.25C18.09 15.25 17.75 14.91 17.75 14.5V9.5C17.75 9.09 18.09 8.75 18.5 8.75C18.91 8.75 19.25 9.09 19.25 9.5V14.5C19.25 14.91 18.91 15.25 18.5 15.25Z"
        fill="currentColor"
      />
      <path
        d="M5 22.75C3.34 22.75 1.78 21.87 0.940002 20.44C0.490002 19.72 0.25 18.87 0.25 18C0.25 15.38 2.38 13.25 5 13.25C7.62 13.25 9.75 15.38 9.75 18C9.75 18.87 9.51 19.72 9.06 20.45C8.22 21.87 6.66 22.75 5 22.75ZM5 14.75C3.21 14.75 1.75 16.21 1.75 18C1.75 18.59 1.91 19.17 2.22 19.67C2.8 20.65 3.87 21.25 5 21.25C6.13 21.25 7.2 20.65 7.78 19.68C8.09 19.17 8.25 18.6 8.25 18C8.25 16.21 6.79 14.75 5 14.75Z"
        fill="currentColor"
      />
      <path
        d="M4.42987 19.7401C4.23987 19.7401 4.04987 19.6701 3.89987 19.5201L2.90988 18.5301C2.61988 18.2401 2.61988 17.76 2.90988 17.47C3.19988 17.18 3.67988 17.18 3.96988 17.47L4.44989 17.9501L6.04987 16.47C6.34987 16.19 6.82986 16.2101 7.10986 16.5101C7.38986 16.8101 7.36989 17.2901 7.06989 17.5701L4.93988 19.54C4.78988 19.67 4.60987 19.7401 4.42987 19.7401Z"
        fill="currentColor"
      />
      <path
        d="M17 20.75H8.5C8.09 20.75 7.75 20.41 7.75 20C7.75 19.59 8.09 19.25 8.5 19.25H17C19.86 19.25 21.25 17.86 21.25 15V9C21.25 6.14 19.86 4.75 17 4.75H7C4.14 4.75 2.75 6.14 2.75 9V15.3C2.75 15.71 2.41 16.05 2 16.05C1.59 16.05 1.25 15.71 1.25 15.3V9C1.25 5.35 3.35 3.25 7 3.25H17C20.65 3.25 22.75 5.35 22.75 9V15C22.75 18.65 20.65 20.75 17 20.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PagesIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11H9.38C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V7C16 7 16 7 16 6.94ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V17Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Settings() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.32 7.55L17.43 6.92L18.32 5.14C18.4102 4.95369 18.4404 4.74397 18.4064 4.53978C18.3723 4.33558 18.2758 4.14699 18.13 4L16 1.87C15.8522 1.72209 15.6618 1.62421 15.4555 1.59013C15.2493 1.55605 15.0375 1.58748 14.85 1.68L13.07 2.57L12.44 0.680003C12.3735 0.482996 12.2472 0.311629 12.0787 0.189751C11.9102 0.0678737 11.7079 0.00154767 11.5 3.33354e-06H8.5C8.29036 -0.000537828 8.08585 0.0648223 7.91537 0.186845C7.7449 0.308868 7.61709 0.481382 7.55 0.680003L6.92 2.57L5.14 1.68C4.95369 1.58978 4.74397 1.55961 4.53978 1.59364C4.33558 1.62767 4.14699 1.72423 4 1.87L1.87 4C1.72209 4.14777 1.62421 4.33818 1.59013 4.54446C1.55605 4.75074 1.58748 4.96251 1.68 5.15L2.57 6.93L0.680003 7.56C0.482996 7.62654 0.311629 7.75283 0.189751 7.92131C0.0678737 8.08979 0.00154767 8.29207 3.33354e-06 8.5V11.5C-0.000537828 11.7096 0.0648223 11.9142 0.186845 12.0846C0.308868 12.2551 0.481382 12.3829 0.680003 12.45L2.57 13.08L1.68 14.86C1.58978 15.0463 1.55961 15.256 1.59364 15.4602C1.62767 15.6644 1.72423 15.853 1.87 16L4 18.13C4.14777 18.2779 4.33818 18.3758 4.54446 18.4099C4.75074 18.444 4.96251 18.4125 5.15 18.32L6.93 17.43L7.56 19.32C7.62709 19.5186 7.7549 19.6911 7.92537 19.8132C8.09585 19.9352 8.30036 20.0005 8.51 20H11.51C11.7196 20.0005 11.9242 19.9352 12.0946 19.8132C12.2651 19.6911 12.3929 19.5186 12.46 19.32L13.09 17.43L14.87 18.32C15.0551 18.4079 15.2628 18.4369 15.4649 18.4029C15.667 18.3689 15.8538 18.2737 16 18.13L18.13 16C18.2779 15.8522 18.3758 15.6618 18.4099 15.4555C18.444 15.2493 18.4125 15.0375 18.32 14.85L17.43 13.07L19.32 12.44C19.517 12.3735 19.6884 12.2472 19.8103 12.0787C19.9321 11.9102 19.9985 11.7079 20 11.5V8.5C20.0005 8.29036 19.9352 8.08585 19.8132 7.91537C19.6911 7.7449 19.5186 7.61709 19.32 7.55ZM18 10.78L16.8 11.18C16.5241 11.2695 16.2709 11.418 16.0581 11.6151C15.8452 11.8122 15.6778 12.0533 15.5675 12.3216C15.4571 12.5899 15.4064 12.879 15.419 13.1688C15.4315 13.4586 15.5069 13.7422 15.64 14L16.21 15.14L15.11 16.24L14 15.64C13.7436 15.5122 13.4627 15.4411 13.1763 15.4313C12.89 15.4215 12.6049 15.4734 12.3403 15.5834C12.0758 15.6934 11.8379 15.8589 11.6429 16.0688C11.4479 16.2787 11.3003 16.5281 11.21 16.8L10.81 18H9.22L8.82 16.8C8.73049 16.5241 8.58203 16.2709 8.3849 16.0581C8.18778 15.8452 7.94671 15.6778 7.67842 15.5675C7.41014 15.4571 7.12105 15.4064 6.83123 15.419C6.5414 15.4315 6.25777 15.5069 6 15.64L4.86 16.21L3.76 15.11L4.36 14C4.4931 13.7422 4.56852 13.4586 4.58105 13.1688C4.59358 12.879 4.5429 12.5899 4.43254 12.3216C4.32218 12.0533 4.15478 11.8122 3.94195 11.6151C3.72912 11.418 3.47595 11.2695 3.2 11.18L2 10.78V9.22L3.2 8.82C3.47595 8.73049 3.72912 8.58203 3.94195 8.3849C4.15478 8.18778 4.32218 7.94671 4.43254 7.67842C4.5429 7.41014 4.59358 7.12105 4.58105 6.83123C4.56852 6.5414 4.4931 6.25777 4.36 6L3.79 4.89L4.89 3.79L6 4.36C6.25777 4.4931 6.5414 4.56852 6.83123 4.58105C7.12105 4.59358 7.41014 4.5429 7.67842 4.43254C7.94671 4.32218 8.18778 4.15478 8.3849 3.94195C8.58203 3.72912 8.73049 3.47595 8.82 3.2L9.22 2H10.78L11.18 3.2C11.2695 3.47595 11.418 3.72912 11.6151 3.94195C11.8122 4.15478 12.0533 4.32218 12.3216 4.43254C12.5899 4.5429 12.879 4.59358 13.1688 4.58105C13.4586 4.56852 13.7422 4.4931 14 4.36L15.14 3.79L16.24 4.89L15.64 6C15.5122 6.25645 15.4411 6.53735 15.4313 6.82369C15.4215 7.11003 15.4734 7.39513 15.5834 7.65969C15.6934 7.92424 15.8589 8.16207 16.0688 8.35708C16.2787 8.5521 16.5281 8.69973 16.8 8.79L18 9.19V10.78ZM10 6C9.20888 6 8.43552 6.2346 7.77772 6.67413C7.11993 7.11365 6.60724 7.73836 6.30448 8.46927C6.00173 9.20017 5.92252 10.0044 6.07686 10.7804C6.2312 11.5563 6.61217 12.269 7.17158 12.8284C7.73099 13.3878 8.44372 13.7688 9.21964 13.9231C9.99557 14.0775 10.7998 13.9983 11.5307 13.6955C12.2616 13.3928 12.8864 12.8801 13.3259 12.2223C13.7654 11.5645 14 10.7911 14 10C14 8.93914 13.5786 7.92172 12.8284 7.17158C12.0783 6.42143 11.0609 6 10 6ZM10 12C9.60444 12 9.21776 11.8827 8.88886 11.6629C8.55996 11.4432 8.30362 11.1308 8.15224 10.7654C8.00087 10.3999 7.96126 9.99778 8.03843 9.60982C8.1156 9.22186 8.30608 8.86549 8.58579 8.58579C8.86549 8.30608 9.22186 8.1156 9.60982 8.03843C9.99778 7.96126 10.3999 8.00087 10.7654 8.15224C11.1308 8.30362 11.4432 8.55996 11.6629 8.88886C11.8827 9.21776 12 9.60444 12 10C12 10.5304 11.7893 11.0391 11.4142 11.4142C11.0391 11.7893 10.5304 12 10 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function InviteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.5H20V9.5C20 9.23478 19.8946 8.98043 19.7071 8.79289C19.5196 8.60536 19.2652 8.5 19 8.5C18.7348 8.5 18.4804 8.60536 18.2929 8.79289C18.1054 8.98043 18 9.23478 18 9.5V10.5H17C16.7348 10.5 16.4804 10.6054 16.2929 10.7929C16.1054 10.9804 16 11.2348 16 11.5C16 11.7652 16.1054 12.0196 16.2929 12.2071C16.4804 12.3946 16.7348 12.5 17 12.5H18V13.5C18 13.7652 18.1054 14.0196 18.2929 14.2071C18.4804 14.3946 18.7348 14.5 19 14.5C19.2652 14.5 19.5196 14.3946 19.7071 14.2071C19.8946 14.0196 20 13.7652 20 13.5V12.5H21C21.2652 12.5 21.5196 12.3946 21.7071 12.2071C21.8946 12.0196 22 11.7652 22 11.5C22 11.2348 21.8946 10.9804 21.7071 10.7929C21.5196 10.6054 21.2652 10.5 21 10.5ZM13.3 12.22C13.8336 11.7581 14.2616 11.1869 14.5549 10.545C14.8482 9.90316 15 9.20571 15 8.5C15 7.17392 14.4732 5.90215 13.5355 4.96447C12.5979 4.02678 11.3261 3.5 10 3.5C8.67392 3.5 7.40215 4.02678 6.46447 4.96447C5.52678 5.90215 5 7.17392 5 8.5C4.99999 9.20571 5.1518 9.90316 5.44513 10.545C5.73845 11.1869 6.16642 11.7581 6.7 12.22C5.30014 12.8539 4.11247 13.8775 3.27898 15.1685C2.4455 16.4596 2.00147 17.9633 2 19.5C2 19.7652 2.10536 20.0196 2.29289 20.2071C2.48043 20.3946 2.73478 20.5 3 20.5C3.26522 20.5 3.51957 20.3946 3.70711 20.2071C3.89464 20.0196 4 19.7652 4 19.5C4 17.9087 4.63214 16.3826 5.75736 15.2574C6.88258 14.1321 8.4087 13.5 10 13.5C11.5913 13.5 13.1174 14.1321 14.2426 15.2574C15.3679 16.3826 16 17.9087 16 19.5C16 19.7652 16.1054 20.0196 16.2929 20.2071C16.4804 20.3946 16.7348 20.5 17 20.5C17.2652 20.5 17.5196 20.3946 17.7071 20.2071C17.8946 20.0196 18 19.7652 18 19.5C17.9985 17.9633 17.5545 16.4596 16.721 15.1685C15.8875 13.8775 14.6999 12.8539 13.3 12.22ZM10 11.5C9.40666 11.5 8.82664 11.3241 8.33329 10.9944C7.83994 10.6648 7.45542 10.1962 7.22836 9.64805C7.0013 9.09987 6.94189 8.49667 7.05764 7.91473C7.1734 7.33279 7.45912 6.79824 7.87868 6.37868C8.29824 5.95912 8.83279 5.6734 9.41473 5.55764C9.99667 5.44189 10.5999 5.5013 11.1481 5.72836C11.6962 5.95542 12.1648 6.33994 12.4944 6.83329C12.8241 7.32664 13 7.90666 13 8.5C13 9.29565 12.6839 10.0587 12.1213 10.6213C11.5587 11.1839 10.7956 11.5 10 11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FeedbackIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3 8.08004C19.019 7.74269 18.6674 7.47113 18.27 7.28452C17.8726 7.0979 17.439 7.0008 17 7.00004H12.44L13 5.57004C13.2329 4.94393 13.3105 4.27065 13.2261 3.60797C13.1416 2.94528 12.8977 2.31297 12.5152 1.76527C12.1327 1.21758 11.623 0.770841 11.0299 0.463388C10.4369 0.155934 9.77804 -0.00305943 9.11 4.45912e-05C8.91764 0.000445953 8.72948 0.0563198 8.56807 0.160967C8.40666 0.265615 8.27887 0.414594 8.2 0.590044L5.35 7.00004H3C2.20435 7.00004 1.44129 7.31611 0.87868 7.87872C0.316071 8.44133 0 9.2044 0 10V17C0 17.7957 0.316071 18.5588 0.87868 19.1214C1.44129 19.684 2.20435 20 3 20H15.73C16.4318 19.9998 17.1113 19.7535 17.6503 19.3041C18.1893 18.8546 18.5537 18.2304 18.68 17.54L19.95 10.54C20.0286 10.1074 20.011 9.66283 19.8987 9.23772C19.7864 8.81262 19.582 8.4174 19.3 8.08004ZM5 18H3C2.73478 18 2.48043 17.8947 2.29289 17.7072C2.10536 17.5196 2 17.2653 2 17V10C2 9.73483 2.10536 9.48047 2.29289 9.29294C2.48043 9.1054 2.73478 9.00004 3 9.00004H5V18ZM18 10.18L16.73 17.18C16.6874 17.413 16.5635 17.6233 16.3804 17.7734C16.1973 17.9236 15.9668 18.0039 15.73 18H7V8.21004L9.72 2.09004C9.99998 2.17167 10.26 2.31045 10.4837 2.49763C10.7073 2.6848 10.8897 2.91631 11.0194 3.17754C11.1491 3.43876 11.2232 3.72404 11.2371 4.01535C11.2509 4.30666 11.2043 4.59768 11.1 4.87004L10.57 6.30005C10.4571 6.6023 10.4189 6.92739 10.4589 7.24758C10.4988 7.56776 10.6156 7.87353 10.7993 8.13878C10.983 8.40404 11.2282 8.62091 11.5139 8.77088C11.7996 8.92086 12.1173 8.99948 12.44 9.00004H17C17.1469 8.99981 17.2921 9.03194 17.4252 9.09416C17.5582 9.15638 17.676 9.24716 17.77 9.36004C17.8663 9.47137 17.9369 9.60259 17.9767 9.74434C18.0164 9.88608 18.0244 10.0349 18 10.18Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ReferIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6.94C17.9896 6.84813 17.9695 6.75763 17.94 6.67V6.58C17.8919 6.47718 17.8278 6.38267 17.75 6.3L11.75 0.3C11.6673 0.222216 11.5728 0.158081 11.47 0.11C11.4402 0.10576 11.4099 0.10576 11.38 0.11C11.2784 0.0517412 11.1662 0.0143442 11.05 0H7C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3V4H3C2.20435 4 1.44129 4.31607 0.87868 4.87868C0.316071 5.44129 0 6.20435 0 7V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H11C11.7956 20 12.5587 19.6839 13.1213 19.1213C13.6839 18.5587 14 17.7956 14 17V16H15C15.7956 16 16.5587 15.6839 17.1213 15.1213C17.6839 14.5587 18 13.7956 18 13V7C18 7 18 7 18 6.94ZM12 3.41L14.59 6H13C12.7348 6 12.4804 5.89464 12.2929 5.70711C12.1054 5.51957 12 5.26522 12 5V3.41ZM12 17C12 17.2652 11.8946 17.5196 11.7071 17.7071C11.5196 17.8946 11.2652 18 11 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V7C2 6.73478 2.10536 6.48043 2.29289 6.29289C2.48043 6.10536 2.73478 6 3 6H4V13C4 13.7956 4.31607 14.5587 4.87868 15.1213C5.44129 15.6839 6.20435 16 7 16H12V17ZM16 13C16 13.2652 15.8946 13.5196 15.7071 13.7071C15.5196 13.8946 15.2652 14 15 14H7C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H10V5C10 5.79565 10.3161 6.55871 10.8787 7.12132C11.4413 7.68393 12.2044 8 13 8H16V13Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HelpIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.29 13.29C9.247 13.3375 9.20693 13.3876 9.17 13.44C9.13216 13.4957 9.10189 13.5563 9.08 13.62C9.05117 13.6767 9.03095 13.7374 9.02001 13.8C9.0151 13.8666 9.0151 13.9334 9.02001 14C9.01663 14.1312 9.04402 14.2613 9.10001 14.38C9.14492 14.5041 9.21657 14.6168 9.30989 14.7101C9.40321 14.8034 9.51591 14.8751 9.64001 14.92C9.75971 14.9729 9.88913 15.0002 10.02 15.0002C10.1509 15.0002 10.2803 14.9729 10.4 14.92C10.5241 14.8751 10.6368 14.8034 10.7301 14.7101C10.8234 14.6168 10.8951 14.5041 10.94 14.38C10.9844 14.2584 11.0048 14.1294 11 14C11.0008 13.8684 10.9755 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29C10.617 13.1963 10.5064 13.1219 10.3846 13.0711C10.2627 13.0203 10.132 12.9942 10 12.9942C9.86799 12.9942 9.73729 13.0203 9.61543 13.0711C9.49357 13.1219 9.38297 13.1963 9.29 13.29ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM10 5C9.47307 4.99966 8.95534 5.13812 8.49891 5.40144C8.04249 5.66476 7.66347 6.04366 7.4 6.5C7.32765 6.61382 7.27907 6.7411 7.25718 6.87418C7.23529 7.00726 7.24055 7.14339 7.27263 7.27439C7.30472 7.40538 7.36297 7.52854 7.44389 7.63643C7.52481 7.74433 7.62671 7.83475 7.74348 7.90224C7.86024 7.96974 7.98945 8.01292 8.12334 8.02918C8.25722 8.04544 8.39301 8.03445 8.52254 7.99688C8.65207 7.9593 8.77266 7.89591 8.87705 7.81052C8.98145 7.72513 9.06749 7.6195 9.13 7.5C9.21811 7.3474 9.34497 7.22078 9.49775 7.13298C9.65053 7.04518 9.82379 6.9993 10 7C10.2652 7 10.5196 7.10536 10.7071 7.29289C10.8946 7.48043 11 7.73478 11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73479 9 9.48043 9.10536 9.2929 9.29289C9.10536 9.48043 9 9.73478 9 10V11C9 11.2652 9.10536 11.5196 9.2929 11.7071C9.48043 11.8946 9.73479 12 10 12C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11V10.82C11.6614 10.58 12.2174 10.1152 12.5708 9.50687C12.9242 8.89851 13.0525 8.18529 12.9334 7.49189C12.8143 6.79849 12.4552 6.16902 11.919 5.71352C11.3828 5.25801 10.7035 5.00546 10 5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TourIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 20.0007H3C2.20435 20.0007 1.44129 19.6846 0.87868 19.122C0.316071 18.5594 0 17.7963 0 17.0007V7.0007C0 6.20505 0.316071 5.44199 0.87868 4.87938C1.44129 4.31677 2.20435 4.0007 3 4.0007H4C4.01682 3.15334 4.30235 2.33322 4.81541 1.65863C5.32848 0.984037 6.04255 0.489846 6.85464 0.247331C7.66673 0.00481649 8.53486 0.026514 9.33382 0.309294C10.1328 0.592074 10.8213 1.12132 11.3 1.8207C11.7484 2.45985 11.9925 3.21996 12 4.0007H15C15.2652 4.0007 15.5196 4.10605 15.7071 4.29359C15.8946 4.48113 16 4.73548 16 5.0007V8.0007C16.8474 8.01752 17.6675 8.30305 18.3421 8.81611C19.0167 9.32917 19.5109 10.0432 19.7534 10.8553C19.9959 11.6674 19.9742 12.5356 19.6914 13.3345C19.4086 14.1335 18.8794 14.822 18.18 15.3007C17.5409 15.7491 16.7807 15.9932 16 16.0007V19.0007C16 19.2659 15.8946 19.5203 15.7071 19.7078C15.5196 19.8953 15.2652 20.0007 15 20.0007ZM3 6.0007C2.73478 6.0007 2.48043 6.10605 2.29289 6.29359C2.10536 6.48113 2 6.73548 2 7.0007V17.0007C2 17.2659 2.10536 17.5203 2.29289 17.7078C2.48043 17.8953 2.73478 18.0007 3 18.0007H14V14.8207C13.9991 14.6604 14.0368 14.5022 14.1099 14.3594C14.183 14.2167 14.2894 14.0937 14.42 14.0007C14.5502 13.9078 14.7008 13.8476 14.8592 13.8249C15.0175 13.8023 15.179 13.818 15.33 13.8707C15.615 13.987 15.9254 14.0269 16.2305 13.9866C16.5357 13.9462 16.825 13.827 17.07 13.6407C17.3139 13.492 17.523 13.2928 17.6834 13.0565C17.8439 12.8202 17.9518 12.5522 18 12.2707C18.0386 11.9868 18.0157 11.6978 17.9329 11.4235C17.85 11.1492 17.7092 10.8959 17.52 10.6807C17.2641 10.3698 16.9155 10.1488 16.5252 10.0499C16.1349 9.95092 15.7231 9.97925 15.35 10.1307C15.199 10.1834 15.0375 10.1991 14.8792 10.1765C14.7208 10.1538 14.5702 10.0936 14.44 10.0007C14.3094 9.9077 14.203 9.78466 14.1299 9.64195C14.0568 9.49924 14.0191 9.34104 14.02 9.1807V6.0007H10.82C10.6557 6.01001 10.4915 5.97861 10.3422 5.90928C10.1929 5.83995 10.0631 5.73483 9.96414 5.60326C9.86522 5.47169 9.8003 5.31773 9.77516 5.15505C9.75001 4.99237 9.76541 4.826 9.82 4.6707C9.93626 4.38571 9.97619 4.07532 9.93586 3.77018C9.89552 3.46504 9.77632 3.17569 9.59 2.9307C9.44235 2.67986 9.24016 2.46547 8.9984 2.30339C8.75663 2.14132 8.4815 2.03572 8.19338 1.99442C7.90527 1.95313 7.61155 1.97719 7.33399 2.06483C7.05644 2.15247 6.80216 2.30144 6.59 2.5007C6.39298 2.69611 6.23877 2.93039 6.1372 3.18863C6.03562 3.44687 5.9889 3.72342 6 4.0007C6.00232 4.23007 6.04637 4.4571 6.13 4.6707C6.18287 4.82192 6.19863 4.98362 6.17597 5.1422C6.1533 5.30078 6.09287 5.4516 5.99976 5.58195C5.90665 5.71231 5.78358 5.81839 5.64093 5.89126C5.49827 5.96413 5.34019 6.00166 5.18 6.0007H3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LogOut() {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H8.59L6.29 13.29C6.19627 13.383 6.12188 13.4936 6.07111 13.6154C6.02034 13.7373 5.9942 13.868 5.9942 14C5.9942 14.132 6.02034 14.2627 6.07111 14.3846C6.12188 14.5064 6.19627 14.617 6.29 14.71C6.38296 14.8037 6.49356 14.8781 6.61542 14.9289C6.73728 14.9797 6.86799 15.0058 7 15.0058C7.13201 15.0058 7.26272 14.9797 7.38458 14.9289C7.50644 14.8781 7.61704 14.8037 7.71 14.71L11.71 10.71C11.801 10.6149 11.8724 10.5028 11.92 10.38C12.02 10.1365 12.02 9.86346 11.92 9.62C11.8724 9.49725 11.801 9.3851 11.71 9.29L7.71 5.29C7.61676 5.19676 7.50607 5.1228 7.38425 5.07234C7.26243 5.02188 7.13186 4.99591 7 4.99591C6.86814 4.99591 6.73757 5.02188 6.61575 5.07234C6.49393 5.1228 6.38324 5.19676 6.29 5.29C6.19676 5.38324 6.1228 5.49393 6.07234 5.61575C6.02188 5.73757 5.99591 5.86814 5.99591 6C5.99591 6.13186 6.02188 6.26243 6.07234 6.38425C6.1228 6.50607 6.19676 6.61676 6.29 6.71L8.59 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10ZM13 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0Z"
        fill="#FC6D6C"
      />
    </svg>
  );
}

export function GridIcon({ onClick, className }) {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
        fill="white"
      />
    </svg>
  );
}

export function FexMobileLogo(props) {
  return !props.blue ? (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 0H17.2683L0 23.4146H6.43902L24 0Z" fill="#3F96D1" />
      <path
        d="M24 23.4143H17.561L8.78049 11.707H15.3659L24 23.4143Z"
        fill="#3F96D1"
      />
      <path
        d="M11.7073 6.73171L8.48776 11.122L-4.19617e-05 0H6.58532L11.7073 6.73171Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 0H17.2683L0 23.4146H6.43902L24 0Z" fill="#3F96D1" />
      <path
        d="M24 23.4143H17.561L8.78049 11.707H15.3659L24 23.4143Z"
        fill="#3F96D1"
      />
      <path
        d="M11.7073 6.73171L8.48776 11.122L-4.19617e-05 0H6.58532L11.7073 6.73171Z"
        fill="#102E51"
      />
    </svg>
  );
}

export function LockIcon({ ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
      />
    </svg>
  );
}

export function CopyLinkIcon({}) {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 6.44984C15.4913 6.37328 15.4746 6.29786 15.45 6.22484V6.14984C15.4099 6.06415 15.3565 5.98539 15.2917 5.9165L10.2917 0.916504C10.2228 0.851684 10.144 0.798238 10.0583 0.75817C10.0335 0.754637 10.0082 0.754637 9.98333 0.75817C9.89868 0.709622 9.80519 0.678457 9.70833 0.666504H6.33333C5.67029 0.666504 5.03441 0.929896 4.56557 1.39874C4.09673 1.86758 3.83333 2.50346 3.83333 3.1665V3.99984H3C2.33696 3.99984 1.70107 4.26323 1.23223 4.73207C0.763392 5.20091 0.5 5.8368 0.5 6.49984V14.8332C0.5 15.4962 0.763392 16.1321 1.23223 16.6009C1.70107 17.0698 2.33696 17.3332 3 17.3332H9.66667C10.3297 17.3332 10.9656 17.0698 11.4344 16.6009C11.9033 16.1321 12.1667 15.4962 12.1667 14.8332V13.9998H13C13.663 13.9998 14.2989 13.7364 14.7678 13.2676C15.2366 12.7988 15.5 12.1629 15.5 11.4998V6.49984C15.5 6.49984 15.5 6.49984 15.5 6.44984ZM10.5 3.50817L12.6583 5.6665H11.3333C11.1123 5.6665 10.9004 5.57871 10.7441 5.42243C10.5878 5.26615 10.5 5.05418 10.5 4.83317V3.50817ZM10.5 14.8332C10.5 15.0542 10.4122 15.2661 10.2559 15.4224C10.0996 15.5787 9.88768 15.6665 9.66667 15.6665H3C2.77899 15.6665 2.56702 15.5787 2.41074 15.4224C2.25446 15.2661 2.16667 15.0542 2.16667 14.8332V6.49984C2.16667 6.27882 2.25446 6.06686 2.41074 5.91058C2.56702 5.7543 2.77899 5.6665 3 5.6665H3.83333V11.4998C3.83333 12.1629 4.09673 12.7988 4.56557 13.2676C5.03441 13.7364 5.67029 13.9998 6.33333 13.9998H10.5V14.8332ZM13.8333 11.4998C13.8333 11.7209 13.7455 11.9328 13.5893 12.0891C13.433 12.2454 13.221 12.3332 13 12.3332H6.33333C6.11232 12.3332 5.90036 12.2454 5.74408 12.0891C5.5878 11.9328 5.5 11.7209 5.5 11.4998V3.1665C5.5 2.94549 5.5878 2.73353 5.74408 2.57725C5.90036 2.42097 6.11232 2.33317 6.33333 2.33317H8.83333V4.83317C8.83333 5.49621 9.09672 6.1321 9.56557 6.60094C10.0344 7.06978 10.6703 7.33317 11.3333 7.33317H13.8333V11.4998Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LeaderBadge({ ...props }) {
  const id = Math.floor(Math.random() * 100);

  return (
    <svg
      {...props}
      style={{ width: "unset !important", height: "unset !important" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5986 7.77948L13.7066 6.47461L13.8026 4.8987C13.8123 4.74013 13.7249 4.59154 13.5817 4.52279L12.1598 3.84018L11.4772 2.41823C11.4075 2.27308 11.2558 2.18547 11.0954 2.19779L9.52532 2.3174L8.22446 1.40417C8.08978 1.30961 7.9103 1.30961 7.77561 1.40417L6.47475 2.31737L4.90472 2.19776C4.74441 2.18545 4.59256 2.27305 4.5229 2.41821L3.84026 3.84016L2.41831 4.52276C2.27315 4.59245 2.1856 4.74404 2.19784 4.90459L2.31745 6.47461L1.40427 7.7755C1.30974 7.91018 1.30974 8.08969 1.40427 8.22437L2.31748 9.52523L2.19787 11.0953C2.18563 11.2558 2.27318 11.4074 2.41834 11.4771L3.84029 12.1597L4.5229 13.5816C4.59258 13.7268 4.74404 13.8144 4.90472 13.8021L6.47475 13.6824L7.77561 14.5957C7.84295 14.6429 7.92149 14.6666 8.00003 14.6666C8.07858 14.6666 8.15712 14.6429 8.22446 14.5957L9.52532 13.6824L11.0954 13.8021C11.2556 13.8143 11.4075 13.7268 11.4772 13.5816L12.1598 12.1597L13.5817 11.4771C13.7269 11.4074 13.8144 11.2558 13.8022 11.0953L13.6826 9.52523L14.5958 8.22437C14.6893 8.09112 14.6904 7.91385 14.5986 7.77948Z"
        fill="#7C7CFE"
      />
      <path
        d="M7.99982 3.70312C5.63052 3.70312 3.70294 5.6307 3.70294 8C3.70294 10.3693 5.63052 12.2969 7.99982 12.2969C10.3691 12.2969 12.2967 10.3693 12.2967 8C12.2967 5.6307 10.3691 3.70312 7.99982 3.70312ZM9.84191 7.90393L9.19834 8.56354L9.35102 9.49961C9.37511 9.64724 9.31274 9.79567 9.19045 9.88182C9.06883 9.96752 8.90808 9.97711 8.77649 9.90435L7.99982 9.47502L7.22313 9.90437C7.09224 9.97674 6.93146 9.96799 6.80917 9.88185C6.68688 9.7957 6.62451 9.64726 6.6486 9.49963L6.80128 8.56357L6.15771 7.90396C6.05547 7.79916 6.02042 7.64599 6.0669 7.50716C6.11336 7.36831 6.23357 7.26713 6.37831 7.24502L7.25193 7.11153L7.6462 6.27154C7.71055 6.13443 7.84836 6.04687 7.99982 6.04687C8.15128 6.04687 8.28907 6.13443 8.35344 6.27151L8.74771 7.11151L9.62133 7.245C9.76607 7.26711 9.88628 7.36831 9.93274 7.50713C9.97922 7.64599 9.94415 7.79914 9.84191 7.90393Z"
        fill={`url(#paint0_linear_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${id}`}
          x1="7.99982"
          y1="12.2969"
          x2="7.99982"
          y2="3.70312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F5EBFD" />
          <stop offset="0.9973" stop-color="#F8F0FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function InvitedBadge({ ...props }) {
  const id = Math.floor(Math.random() * 100);

  return (
    <svg
      style={{ width: "0.8125rem !important", height: "0.8125rem !important" }}
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5986 7.77948L13.7066 6.47461L13.8026 4.8987C13.8123 4.74013 13.7249 4.59154 13.5817 4.52279L12.1598 3.84018L11.4772 2.41823C11.4075 2.27308 11.2558 2.18547 11.0954 2.19779L9.52532 2.3174L8.22446 1.40417C8.08978 1.30961 7.9103 1.30961 7.77561 1.40417L6.47475 2.31737L4.90472 2.19776C4.74441 2.18545 4.59256 2.27305 4.5229 2.41821L3.84026 3.84016L2.41831 4.52276C2.27315 4.59245 2.1856 4.74404 2.19784 4.90459L2.31745 6.47461L1.40427 7.7755C1.30974 7.91018 1.30974 8.08969 1.40427 8.22437L2.31748 9.52523L2.19787 11.0953C2.18563 11.2558 2.27318 11.4074 2.41834 11.4771L3.84029 12.1597L4.5229 13.5816C4.59258 13.7268 4.74404 13.8144 4.90472 13.8021L6.47475 13.6824L7.77561 14.5957C7.84295 14.6429 7.92149 14.6666 8.00003 14.6666C8.07858 14.6666 8.15712 14.6429 8.22446 14.5957L9.52532 13.6824L11.0954 13.8021C11.2556 13.8143 11.4075 13.7268 11.4772 13.5816L12.1598 12.1597L13.5817 11.4771C13.7269 11.4074 13.8144 11.2558 13.8022 11.0953L13.6826 9.52523L14.5958 8.22437C14.6893 8.09112 14.6904 7.91385 14.5986 7.77948Z"
        fill="#FFCA2Cb0"
      />
      <path
        d="M7.99982 3.70312C5.63052 3.70312 3.70294 5.6307 3.70294 8C3.70294 10.3693 5.63052 12.2969 7.99982 12.2969C10.3691 12.2969 12.2967 10.3693 12.2967 8C12.2967 5.6307 10.3691 3.70312 7.99982 3.70312ZM9.84191 7.90393L9.19834 8.56354L9.35102 9.49961C9.37511 9.64724 9.31274 9.79567 9.19045 9.88182C9.06883 9.96752 8.90808 9.97711 8.77649 9.90435L7.99982 9.47502L7.22313 9.90437C7.09224 9.97674 6.93146 9.96799 6.80917 9.88185C6.68688 9.7957 6.62451 9.64726 6.6486 9.49963L6.80128 8.56357L6.15771 7.90396C6.05547 7.79916 6.02042 7.64599 6.0669 7.50716C6.11336 7.36831 6.23357 7.26713 6.37831 7.24502L7.25193 7.11153L7.6462 6.27154C7.71055 6.13443 7.84836 6.04687 7.99982 6.04687C8.15128 6.04687 8.28907 6.13443 8.35344 6.27151L8.74771 7.11151L9.62133 7.245C9.76607 7.26711 9.88628 7.36831 9.93274 7.50713C9.97922 7.64599 9.94415 7.79914 9.84191 7.90393Z"
        fill={`url(#paint0_linear_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${id}`}
          x1="7.99982"
          y1="12.2969"
          x2="7.99982"
          y2="3.70312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F5EBFD" />
          <stop offset="0.9973" stop-color="#F8F0FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Clients(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11C9.79113 11 10.5645 10.7654 11.2223 10.3259C11.8801 9.88635 12.3928 9.26164 12.6955 8.53074C12.9983 7.79983 13.0775 6.99556 12.9231 6.21964C12.7688 5.44372 12.3878 4.73098 11.8284 4.17157C11.269 3.61216 10.5563 3.2312 9.78036 3.07686C9.00444 2.92252 8.20017 3.00173 7.46927 3.30448C6.73836 3.60723 6.11365 4.11992 5.67412 4.77772C5.2346 5.43552 5 6.20888 5 7C5 8.06087 5.42143 9.07828 6.17157 9.82843C6.92172 10.5786 7.93913 11 9 11Z"
        fill="currentColor"
      />
      <path
        d="M17 13C17.5933 13 18.1734 12.8241 18.6667 12.4944C19.1601 12.1648 19.5446 11.6962 19.7716 11.1481C19.9987 10.5999 20.0581 9.99667 19.9424 9.41473C19.8266 8.83279 19.5409 8.29824 19.1213 7.87868C18.7018 7.45912 18.1672 7.1734 17.5853 7.05765C17.0033 6.94189 16.4001 7.0013 15.8519 7.22836C15.3038 7.45543 14.8352 7.83994 14.5056 8.33329C14.1759 8.82664 14 9.40666 14 10C14 10.7957 14.3161 11.5587 14.8787 12.1213C15.4413 12.6839 16.2044 13 17 13Z"
        fill="currentColor"
      />
      <path
        d="M21 19.9983C21.2652 19.9983 21.5196 19.893 21.7071 19.7055C21.8946 19.5179 22 19.2636 22 18.9983C21.9992 18.0637 21.7365 17.1481 21.2416 16.3552C20.7468 15.5624 20.0396 14.9241 19.2003 14.5128C18.3611 14.1015 17.4234 13.9337 16.4936 14.0283C15.5638 14.123 14.6791 14.4764 13.94 15.0483C12.9605 14.0727 11.7141 13.4089 10.3578 13.1408C9.00159 12.8726 7.59632 13.012 6.31923 13.5415C5.04213 14.0709 3.95041 14.9667 3.18174 16.1158C2.41307 17.2649 2.00187 18.6159 2 19.9983C2 20.2636 2.10536 20.5179 2.29289 20.7055C2.48043 20.893 2.73478 20.9983 3 20.9983H15C15.2652 20.9983 15.5196 20.893 15.7071 20.7055C15.8946 20.5179 16 20.2636 16 19.9983"
        fill="currentColor"
      />
    </svg>
  );
}

export function TeamsIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2973_16508)">
        <path
          d="M14 19H10C9.724 19 9.5 19.224 9.5 19.5C9.5 19.776 9.724 20 10 20H14C14.276 20 14.5 19.776 14.5 19.5C14.5 19.224 14.276 19 14 19ZM14 21H10C9.724 21 9.5 21.224 9.5 21.5C9.5 21.776 9.724 22 10 22H14C14.276 22 14.5 21.776 14.5 21.5C14.5 21.224 14.276 21 14 21ZM14.25 23H9.75L10.938 23.782C11.092 23.92 11.318 24 11.553 24H12.448C12.682 24 12.909 23.92 13.063 23.782L14.25 23ZM18 9.201C18 12.77 14.786 15.184 14.786 18H9.214C9.214 15.184 6 12.77 6 9.201C6 5.478 8.998 3.429 11.997 3.429C14.998 3.429 18 5.48 18 9.201ZM22 8.51V9.882H19.462C19.482 9.659 19.5 9.434 19.5 9.201C19.5 8.964 19.483 8.737 19.465 8.511H22V8.51ZM11.352 1.957V0H12.723V1.964C12.481 1.942 12.239 1.929 11.997 1.929C11.782 1.929 11.567 1.939 11.352 1.957ZM7.609 3.251L6.569 1.311L7.777 0.663L8.814 2.596C8.396 2.777 7.992 2.997 7.609 3.251ZM18.195 4.986L20.137 3.592L20.936 4.707L18.882 6.18C18.691 5.75 18.459 5.353 18.195 4.986ZM15.185 2.597L16.223 0.663L17.431 1.311L16.39 3.252C16.008 2.998 15.604 2.779 15.185 2.597ZM5.117 6.18L3.063 4.708L3.862 3.593L5.804 4.986C5.54 5.352 5.309 5.749 5.117 6.18ZM18.824 12.403L21.178 13.357L20.664 14.628L18.239 13.646C18.449 13.249 18.647 12.834 18.824 12.403ZM5.716 13.558L3.36 14.618L2.798 13.367L5.138 12.315C5.311 12.748 5.509 13.16 5.716 13.558ZM4.538 9.882H2V8.51H4.535C4.517 8.736 4.5 8.964 4.5 9.201C4.5 9.434 4.518 9.659 4.538 9.882Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2973_16508">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ProjectsIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2V22H2V2H22ZM24 0H0V24H24V0ZM20 7H12V8H20V7ZM20 12H12V13H20V12ZM20 17H12V18H20V17ZM9.484 5.696L8.774 5L6.221 7.607L4.682 6.155L3.984 6.865L6.234 9L9.484 5.696ZM9.484 10.696L8.774 10L6.222 12.607L4.683 11.155L3.985 11.864L6.234 14L9.484 10.696ZM9.484 15.696L8.774 15L6.222 17.607L4.683 16.155L3.985 16.864L6.234 19L9.484 15.696Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TasksIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 22H19C20.103 22 21 21.103 21 20V5C21 3.897 20.103 3 19 3H17C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3H5C3.897 3 3 3.897 3 5V20C3 21.103 3.897 22 5 22ZM5 5H7V7H17V5H19V20H5V5Z"
        fill="currentColor"
      />
      <path
        d="M11 13.586L9.20697 11.793L7.79297 13.207L11 16.414L16.207 11.207L14.793 9.79297L11 13.586Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AssetIcon(props) {
  return (
    <svg
      {...props}
      id="Layer_1_1_"
      width="24"
      height="24"
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M1,63h48V1H1V63z M3,3h44v58H3V3z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M24,17v2h2v-2c1.654,0,3-1.346,3-3s-1.346-3-3-3h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2   c0.552,0,1,0.448,1,1v1h2v-1c0-1.654-1.346-3-3-3V5h-2v2c-1.654,0-3,1.346-3,3s1.346,3,3,3h2c0.552,0,1,0.448,1,1s-0.448,1-1,1h-2   c-0.552,0-1-0.448-1-1v-1h-2v1C21,15.654,22.346,17,24,17z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M33,23H5v22h28v8h12v-8v-1V24v-1v-4H33V23z M33,25v2H11v2h22v2H7v-2h2v-2H7v-2H33z M43,35h-2v2h2v2   h-8v-2h4v-2h-4v-2h8V35z M43,41v2h-8v-2H43z M33,37v2H7v-2H33z M7,35v-2h26v2H7z M43,31h-8v-2h8V31z M43,27h-8v-2h8V27z M7,43v-2   h26v2H7z M43,51h-8v-6h8V51z M43,21v2h-8v-2H43z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M62,49.937V6c0-2.757-2.243-5-5-5s-5,2.243-5,5v43.937l-1.073,8.585L57,62.166l6.073-3.644   L62,49.937z M54,49V13h6v36H54z M60,11h-6V9h6V11z M57,3c1.654,0,3,1.346,3,3v1h-6V6C54,4.346,55.346,3,57,3z M57,59.834   l-3.927-2.356L53.883,51H56v4h2v-4h2.117l0.81,6.478L57,59.834z"
          style={{ fill: "currentColor" }}
        />
        <rect
          height="2"
          style={{ fill: "currentColor" }}
          width="2"
          x="31"
          y="11"
        />
        <rect
          height="2"
          style={{ fill: "currentColor" }}
          width="2"
          x="17"
          y="11"
        />
      </g>
    </svg>
  );
}

export function ViewTasksIcon(props) {
  return (
    <svg
      {...props}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.35184 8H9.24073V9.25H5.35184V8ZM11.8333 1.75V13.625C11.8333 14.6588 10.9609 15.5 9.88888 15.5H2.1111C1.03906 15.5 0.166656 14.6588 0.166656 13.625V1.75H3.51823C3.78592 1.0225 4.50666 0.5 5.35184 0.5H6.64814C7.49332 0.5 8.21407 1.0225 8.48175 1.75H11.8333ZM10.537 3H7.29629V2.375C7.29629 2.03 7.00527 1.75 6.64814 1.75H5.35184C4.99471 1.75 4.70369 2.03 4.70369 2.375V3H1.46295V13.625C1.46295 13.97 1.75397 14.25 2.1111 14.25H9.88888C10.246 14.25 10.537 13.97 10.537 13.625V3ZM5.35184 6.75H9.24073V5.5H5.35184V6.75ZM5.35184 11.75H9.24073V10.5H5.35184V11.75ZM2.75925 6.75H4.05555V5.5H2.75925V6.75ZM2.75925 9.25H4.05555V8H2.75925V9.25ZM2.75925 11.75H4.05555V10.5H2.75925V11.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ViewPerformanceIcon(props) {
  return (
    <svg
      {...props}
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99991 0.500013C0.900139 0.487059 -2.43465 10.8432 4.20149 15.3759L4.38192 15.5H13.6179L13.7983 15.3759C20.4373 10.8411 17.0955 0.486377 8.99991 0.500013ZM13.1714 14.1364H4.82846C-0.49731 10.2636 2.36098 1.84729 8.99991 1.86365C15.6388 1.84729 18.4971 10.265 13.1714 14.1364ZM10.3848 8.53183L14.2414 10.1886L13.6841 11.4377L9.82682 9.78092C9.58001 9.95918 9.27999 10.0527 8.9733 10.0471C8.66662 10.0414 8.37041 9.93689 8.13063 9.74967C7.89085 9.56244 7.72089 9.30301 7.64714 9.0116C7.57338 8.72019 7.59993 8.41311 7.72269 8.13798C7.84544 7.86286 8.05753 7.63507 8.32605 7.48995C8.59457 7.34483 8.90452 7.2905 9.20781 7.33538C9.51111 7.38027 9.79079 7.52185 10.0035 7.73818C10.2162 7.9545 10.3507 8.23348 10.3848 8.53183ZM14.573 8.68182C14.573 8.73432 14.5667 8.78614 14.5653 8.83864L13.1532 8.23183C13.0391 7.23147 12.5525 6.30731 11.7864 5.63574C11.0203 4.96418 10.0284 4.59224 8.99991 4.59092C5.33004 4.52274 3.40036 9.14751 6.07753 11.6034L5.10224 12.5784C1.53826 9.25796 4.08097 3.17001 8.99991 3.22728C10.4775 3.22891 11.894 3.8041 12.9388 4.82668C13.9836 5.84925 14.5713 7.23569 14.573 8.68182Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PerformanceIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H24V22H0V0ZM22 20V5H2V20H22ZM16.545 9.52L12.402 13.099C11.727 12.961 11.001 13.167 10.508 13.717C9.773 14.541 9.843 15.805 10.667 16.541C11.49 17.277 12.755 17.206 13.491 16.383C13.983 15.832 14.107 15.087 13.893 14.432L17 9.925L16.545 9.52ZM7 16H4C4 11.585 7.585 8 12 8C13.163 8 14.269 8.249 15.267 8.696L12.477 11.022L12 11C9.241 11 7 13.24 7 16ZM20 16H17C17 15.136 16.781 14.324 16.395 13.615L18.124 10.854C19.294 12.246 20 14.041 20 16Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ReportsIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 8L14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8ZM9 19H7V10H9V19ZM13 19H11V13H13V19ZM17 19H15V16H17V19ZM14 9H13V4L18 9H14Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DashboardIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function SchedulesIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V12H20V19ZM20 10H4V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V10Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function MeetingIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.53 7.15C21.378 7.06223 21.2055 7.01603 21.03 7.01603C20.8545 7.01603 20.682 7.06223 20.53 7.15L17 8.89C16.9715 8.11357 16.6429 7.37847 16.0834 6.83944C15.5238 6.3004 14.777 5.99948 14 6H5C4.20435 6 3.44129 6.31607 2.87868 6.87868C2.31607 7.44129 2 8.20435 2 9V15C2 15.7957 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H14C14.777 18.0005 15.5238 17.6996 16.0834 17.1606C16.6429 16.6215 16.9715 15.8864 17 15.11L20.56 16.89C20.6963 16.9599 20.8468 16.9975 21 17C21.1872 17.0006 21.3709 16.9486 21.53 16.85C21.6741 16.7599 21.7929 16.6346 21.8751 16.4859C21.9574 16.3372 22.0003 16.1699 22 16V8C22.0003 7.83006 21.9574 7.66283 21.8751 7.51411C21.7929 7.36538 21.6741 7.24007 21.53 7.15ZM15 15C15 15.2652 14.8946 15.5196 14.7071 15.7071C14.5196 15.8946 14.2652 16 14 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V9C4 8.73478 4.10536 8.48043 4.29289 8.29289C4.48043 8.10536 4.73478 8 5 8H14C14.2652 8 14.5196 8.10536 14.7071 8.29289C14.8946 8.48043 15 8.73478 15 9V15ZM20 14.38L17 12.88V11.12L20 9.62V14.38Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function ConversationsIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 8H18V5C18 4.20435 17.6839 3.44129 17.1213 2.87868C16.5587 2.31607 15.7956 2 15 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V17C2.00099 17.1974 2.06039 17.3901 2.17072 17.5539C2.28105 17.7176 2.43738 17.845 2.62 17.92C2.73868 17.976 2.86882 18.0034 3 18C3.13161 18.0008 3.26207 17.9755 3.38391 17.9258C3.50574 17.876 3.61656 17.8027 3.71 17.71L6.52 14.89H8V16.33C8 17.1256 8.31607 17.8887 8.87868 18.4513C9.44129 19.0139 10.2044 19.33 11 19.33H17.92L20.29 21.71C20.3834 21.8027 20.4943 21.876 20.6161 21.9258C20.7379 21.9755 20.8684 22.0008 21 22C21.1312 22.0034 21.2613 21.976 21.38 21.92C21.5626 21.845 21.7189 21.7176 21.8293 21.5539C21.9396 21.3901 21.999 21.1974 22 21V11C22 10.2044 21.6839 9.44129 21.1213 8.87868C20.5587 8.31607 19.7956 8 19 8ZM8 11V12.89H6.11C5.97839 12.8892 5.84793 12.9145 5.72609 12.9642C5.60426 13.014 5.49344 13.0873 5.4 13.18L4 14.59V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H15C15.2652 4 15.5196 4.10536 15.7071 4.29289C15.8946 4.48043 16 4.73478 16 5V8H11C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11ZM20 18.59L19 17.59C18.9074 17.4955 18.7969 17.4203 18.6751 17.3688C18.5532 17.3173 18.4223 17.2906 18.29 17.29H11C10.7348 17.29 10.4804 17.1846 10.2929 16.9971C10.1054 16.8096 10 16.5552 10 16.29V11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H19C19.2652 10 19.5196 10.1054 19.7071 10.2929C19.8946 10.4804 20 10.7348 20 11V18.59Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function TeamIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function FeedIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.41 8.64013C21.41 8.64013 21.41 8.64013 21.41 8.59013C20.7054 6.66635 19.4269 5.00541 17.7475 3.83199C16.0681 2.65857 14.0688 2.0293 12.02 2.0293C9.97126 2.0293 7.97195 2.65857 6.29252 3.83199C4.6131 5.00541 3.33461 6.66635 2.63001 8.59013C2.63001 8.59013 2.63001 8.59013 2.63001 8.64013C1.84314 10.811 1.84314 13.1892 2.63001 15.3601C2.63001 15.3601 2.63001 15.3601 2.63001 15.4101C3.33461 17.3339 4.6131 18.9948 6.29252 20.1683C7.97195 21.3417 9.97126 21.971 12.02 21.971C14.0688 21.971 16.0681 21.3417 17.7475 20.1683C19.4269 18.9948 20.7054 17.3339 21.41 15.4101C21.41 15.4101 21.41 15.4101 21.41 15.3601C22.1969 13.1892 22.1969 10.811 21.41 8.64013ZM4.26001 14.0001C3.91324 12.6893 3.91324 11.3109 4.26001 10.0001H6.12001C5.96004 11.3287 5.96004 12.6716 6.12001 14.0001H4.26001ZM5.08001 16.0001H6.48001C6.71473 16.892 7.05022 17.7542 7.48001 18.5701C6.49931 17.9021 5.67951 17.0242 5.08001 16.0001ZM6.48001 8.00013H5.08001C5.67088 6.97921 6.4802 6.10159 7.45001 5.43013C7.03057 6.24737 6.70515 7.10954 6.48001 8.00013ZM11 19.7001C9.77178 18.7988 8.90916 17.4854 8.57001 16.0001H11V19.7001ZM11 14.0001H8.14001C7.9534 12.6733 7.9534 11.3269 8.14001 10.0001H11V14.0001ZM11 8.00013H8.57001C8.90916 6.51489 9.77178 5.20144 11 4.30013V8.00013ZM18.92 8.00013H17.52C17.2853 7.10828 16.9498 6.24606 16.52 5.43013C17.5007 6.0982 18.3205 6.97607 18.92 8.00013ZM13 4.30013C14.2282 5.20144 15.0909 6.51489 15.43 8.00013H13V4.30013ZM13 19.7001V16.0001H15.43C15.0909 17.4854 14.2282 18.7988 13 19.7001ZM15.86 14.0001H13V10.0001H15.86C16.0466 11.3269 16.0466 12.6733 15.86 14.0001ZM16.55 18.5701C16.9798 17.7542 17.3153 16.892 17.55 16.0001H18.95C18.3505 17.0242 17.5307 17.9021 16.55 18.5701ZM19.74 14.0001H17.88C17.9613 13.3366 18.0014 12.6686 18 12.0001C18.0011 11.3316 17.961 10.6637 17.88 10.0001H19.74C20.0868 11.3109 20.0868 12.6893 19.74 14.0001Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function NotiBellIcon(props) {
  return (
    <svg
      {...props}
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-white"
    >
      <path
        d="M18.8275 16.7119L17.7344 15.9831V9.65625C17.7344 5.62852 14.6395 2.31061 10.7031 1.95417V0.703125C10.7031 0.314812 10.3883 0 10 0C9.61169 0 9.29688 0.314812 9.29688 0.703125V1.95417C5.36045 2.31061 2.26562 5.62852 2.26562 9.65625V15.9831L1.1725 16.7119C0.976844 16.8423 0.859375 17.0618 0.859375 17.2969V20.1094C0.859375 20.4977 1.17419 20.8125 1.5625 20.8125H6.19727C6.52731 22.6231 8.1063 24 10 24C11.8937 24 13.4727 22.6231 13.8027 20.8125H18.4375C18.8258 20.8125 19.1406 20.4977 19.1406 20.1094V17.2969C19.1406 17.0618 19.0231 16.8422 18.8275 16.7119ZM10 22.5938C8.88489 22.5938 7.94055 21.841 7.63942 20.8125H12.3606C12.0595 21.841 11.1151 22.5938 10 22.5938ZM17.7344 19.4062C17.0818 19.4062 3.03372 19.4062 2.26562 19.4062V17.6731L3.35875 16.9444C3.55436 16.814 3.67188 16.5945 3.67188 16.3594V9.65625C3.67188 6.16692 6.51067 3.32812 10 3.32812C13.4893 3.32812 16.3281 6.16692 16.3281 9.65625V16.3594C16.3281 16.5945 16.4456 16.814 16.6412 16.9444L17.7344 17.6731V19.4062Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function NotiChatIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.10064 17.8127C4.15689 17.6074 4.03361 17.322 3.91595 17.1162C3.87948 17.0547 3.83974 16.9953 3.79689 16.9381C2.7878 15.4077 2.24995 13.6149 2.25002 11.7818C2.23314 6.52009 6.59627 2.25024 11.9916 2.25024C16.6969 2.25024 20.625 5.50993 21.5423 9.83696C21.68 10.4785 21.7496 11.1327 21.75 11.7888C21.75 17.0581 17.5552 21.3949 12.1599 21.3949C11.3016 21.3949 10.1442 21.1793 9.51283 21.0026C8.88142 20.8259 8.25095 20.5915 8.0883 20.5287C7.92178 20.4647 7.74495 20.4318 7.56658 20.4316C7.37207 20.431 7.17944 20.4697 7.00033 20.5455L3.82033 21.693C3.75084 21.7231 3.67718 21.7424 3.60189 21.7502C3.54234 21.7501 3.48341 21.7381 3.42852 21.715C3.37363 21.6919 3.32386 21.6581 3.2821 21.6157C3.24034 21.5732 3.20741 21.5229 3.18522 21.4676C3.16303 21.4123 3.15202 21.3532 3.15283 21.2937C3.15674 21.2414 3.16617 21.1897 3.18096 21.1395L4.10064 17.8127Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      ></path>
      <path
        d="M7.49982 13.5005C8.32824 13.5005 8.99982 12.8289 8.99982 12.0005C8.99982 11.1721 8.32824 10.5005 7.49982 10.5005C6.67139 10.5005 5.99982 11.1721 5.99982 12.0005C5.99982 12.8289 6.67139 13.5005 7.49982 13.5005Z"
        fill="white"
      ></path>
      <path
        d="M12 13.5005C12.8285 13.5005 13.5 12.8289 13.5 12.0005C13.5 11.1721 12.8285 10.5005 12 10.5005C11.1716 10.5005 10.5 11.1721 10.5 12.0005C10.5 12.8289 11.1716 13.5005 12 13.5005Z"
        fill="white"
      ></path>
      <path
        d="M16.5 13.5005C17.3284 13.5005 18 12.8289 18 12.0005C18 11.1721 17.3284 10.5005 16.5 10.5005C15.6716 10.5005 15 11.1721 15 12.0005C15 12.8289 15.6716 13.5005 16.5 13.5005Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function NotiNoteIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M12.527 24.0002C12.33 24.0002 12.138 23.9222 11.997 23.7802C11.824 23.6072 11.746 23.3602 11.789 23.1202L12.319 20.1152C12.346 19.9632 12.419 19.8232 12.527 19.7152L19.952 12.2902C20.268 11.9742 20.603 11.7762 20.948 11.7052C21.424 11.6052 21.887 11.7502 22.25 12.1132L23.487 13.3502C24.169 14.0332 24.169 15.1422 23.487 15.8252L16.063 23.2502C15.954 23.3582 15.814 23.4322 15.663 23.4582L12.658 23.9882C12.614 23.9962 12.571 24.0002 12.527 24.0002ZM15.533 22.7202H15.543H15.533ZM13.755 20.6082L13.452 22.3252L15.169 22.0222L22.426 14.7642C22.523 14.6662 22.523 14.5082 22.426 14.4102L21.198 13.1822C21.188 13.2012 21.113 13.2482 21.012 13.3492L13.755 20.6082Z"
          fill="white"
        ></path>
        <path
          d="M10.01 21H2.75C1.233 21 0 19.767 0 18.25V4.75C0 3.233 1.233 2 2.75 2H14.25C15.767 2 17 3.233 17 4.75V12.81C17 13.224 16.664 13.56 16.25 13.56C15.836 13.56 15.5 13.224 15.5 12.81V4.75C15.5 4.061 14.939 3.5 14.25 3.5H2.75C2.061 3.5 1.5 4.061 1.5 4.75V18.25C1.5 18.939 2.061 19.5 2.75 19.5H10.01C10.424 19.5 10.76 19.836 10.76 20.25C10.76 20.664 10.424 21 10.01 21Z"
          fill="white"
        ></path>
        <path
          d="M3.75 5C3.336 5 3 4.664 3 4.25V0.75C3 0.336 3.336 0 3.75 0C4.164 0 4.5 0.336 4.5 0.75V4.25C4.5 4.664 4.164 5 3.75 5Z"
          fill="white"
        ></path>
        <path
          d="M8.50031 5C8.08631 5 7.75031 4.664 7.75031 4.25V0.75C7.75031 0.336 8.08631 0 8.50031 0C8.91431 0 9.25031 0.336 9.25031 0.75V4.25C9.25031 4.664 8.91431 5 8.50031 5Z"
          fill="white"
        ></path>
        <path
          d="M13.2497 5C12.8357 5 12.4997 4.664 12.4997 4.25V0.75C12.4997 0.336 12.8357 0 13.2497 0C13.6637 0 13.9997 0.336 13.9997 0.75V4.25C13.9997 4.664 13.6637 5 13.2497 5Z"
          fill="white"
        ></path>
        <path
          d="M11.25 13.5H3.75C3.336 13.5 3 13.164 3 12.75C3 12.336 3.336 12 3.75 12H11.25C11.664 12 12 12.336 12 12.75C12 13.164 11.664 13.5 11.25 13.5Z"
          fill="white"
        ></path>
        <path
          d="M8.25 9.5H3.75C3.336 9.5 3 9.164 3 8.75C3 8.336 3.336 8 3.75 8H8.25C8.664 8 9 8.336 9 8.75C9 9.164 8.664 9.5 8.25 9.5Z"
          fill="white"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export function NotiInviteIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M17.625 6.75C17.4413 9.22828 15.5625 11.25 13.5 11.25C11.4375 11.25 9.55549 9.22875 9.37502 6.75C9.18752 4.17187 11.0156 2.25 13.5 2.25C15.9844 2.25 17.8125 4.21875 17.625 6.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M13.5001 14.25C9.42193 14.25 5.28287 16.5 4.51693 20.7469C4.42318 21.2587 4.71428 21.75 5.25053 21.75H21.7501C22.2863 21.75 22.576 21.2587 22.4836 20.7469C21.7172 16.5 17.5782 14.25 13.5001 14.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        ></path>
        <path
          d="M4.125 8.24902V13.499"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M6.75004 10.874H1.50005"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export function ShareBg(props) {
  return (
    <svg
      {...props}
      width="1440"
      height="900"
      viewBox="0 0 1440 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="346"
        y="-14"
        width="965"
        height="965"
        rx="482.5"
        fill="url(#paint0_linear_3218_16607)"
      />
      <rect
        width="594.985"
        height="594.985"
        rx="297.492"
        transform="matrix(-0.937024 0.349264 0.349264 0.937024 348.092 228.795)"
        fill="url(#paint1_linear_3218_16607)"
      />
      <path
        d="M532 31.5C532 78.4731 518.071 124.391 491.974 163.448C465.877 202.505 428.785 232.946 385.387 250.921C341.99 268.897 294.237 273.6 248.166 264.436C202.096 255.273 159.777 232.653 126.562 199.438C93.3472 166.223 70.7275 123.904 61.5635 77.834C52.3995 31.7635 57.1028 -15.9899 75.0786 -59.3873C93.0544 -102.785 123.495 -139.877 162.552 -165.974C201.609 -192.071 247.527 -206 294.5 -206V-41.3296C280.096 -41.3296 266.015 -37.0582 254.038 -29.0556C242.061 -21.053 232.727 -9.67856 227.214 3.6293C221.702 16.9372 220.26 31.5808 223.07 45.7084C225.88 59.8359 232.816 72.8129 243.002 82.9983C253.187 93.1837 266.164 100.12 280.292 102.93C294.419 105.74 309.063 104.298 322.371 98.7858C335.679 93.2735 347.053 83.9388 355.056 71.962C363.058 59.9852 367.33 45.9043 367.33 31.5H532Z"
        fill="url(#paint2_radial_3218_16607)"
        fill-opacity="0.3"
      />
      <path
        d="M1290 706C1345.58 706 1399.91 689.52 1446.12 658.643C1492.33 627.766 1528.34 583.88 1549.61 532.534C1570.88 481.188 1576.44 424.688 1565.6 370.18C1554.76 315.671 1528 265.602 1488.7 226.303C1449.4 187.004 1399.33 160.242 1344.82 149.399C1290.31 138.557 1233.81 144.122 1182.47 165.39C1131.12 186.658 1087.23 222.675 1056.36 268.885C1025.48 315.095 1009 369.423 1009 425L1212.15 425C1212.15 409.603 1216.72 394.552 1225.27 381.749C1233.83 368.947 1245.98 358.969 1260.21 353.077C1274.43 347.185 1290.09 345.643 1305.19 348.647C1320.29 351.651 1334.16 359.065 1345.05 369.952C1355.93 380.84 1363.35 394.711 1366.35 409.812C1369.36 424.914 1367.82 440.566 1361.92 454.792C1356.03 469.017 1346.05 481.175 1333.25 489.729C1320.45 498.283 1305.4 502.849 1290 502.849V706Z"
        fill="url(#paint3_radial_3218_16607)"
        fill-opacity="0.3"
      />
      <path
        d="M-64.5 1015C-17.5269 1015 28.3913 1001.07 67.4479 974.974C106.505 948.877 136.946 911.785 154.921 868.387C172.897 824.99 177.6 777.237 168.436 731.166C159.273 685.096 136.653 642.777 103.438 609.562C70.2229 576.347 27.9044 553.727 -18.1661 544.563C-64.2366 535.4 -111.99 540.103 -155.387 558.079C-198.785 576.054 -235.877 606.495 -261.974 645.552C-288.071 684.609 -302 730.527 -302 777.5L-157.223 777.5C-157.223 759.161 -151.784 741.234 -141.596 725.986C-131.408 710.738 -116.926 698.854 -99.9834 691.836C-83.0406 684.818 -64.3972 682.981 -46.4107 686.559C-28.4243 690.137 -11.9028 698.968 1.06473 711.935C14.0322 724.903 22.8632 741.424 26.4409 759.411C30.0186 777.397 28.1824 796.041 21.1645 812.983C14.1465 829.926 2.26204 844.408 -12.9861 854.596C-28.2343 864.784 -46.1612 870.223 -64.5 870.223L-64.5 1015Z"
        fill="url(#paint4_linear_3218_16607)"
        fill-opacity="0.3"
      />
      <circle cx="-139" cy="-62" r="435.5" stroke="#F3F5F7" />
      <circle cx="1266.5" cy="-114.5" r="213" stroke="#F3F5F7" />
      <circle cx="710" cy="659" r="181.5" stroke="#F3F5F7" />
      <circle cx="199" cy="306" r="4" fill="#EEF4F9" />
      <circle cx="1206" cy="244" r="7" fill="#EEF4F9" />
      <circle cx="1205.5" cy="88.5" r="5.5" fill="#EEF4F9" />
      <circle cx="1303.5" cy="622.5" r="5.5" fill="#EEF4F9" />
      <circle cx="544.5" cy="734.5" r="5.5" fill="#EEF4F9" />
      <circle cx="39.5" cy="336.5" r="10.5" fill="#EEF4F9" />
      <circle cx="265.5" cy="96.5" r="3.5" fill="#EEF4F9" />
      <circle cx="1308.5" cy="307.5" r="3.5" fill="#EEF4F9" />
      <defs>
        <linearGradient
          id="paint0_linear_3218_16607"
          x1="336.784"
          y1="-14"
          x2="1393.94"
          y2="900.314"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBFBFB" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3218_16607"
          x1="-5.68199"
          y1="6.28147e-06"
          x2="646.123"
          y2="563.734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBFBFB" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_3218_16607"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(179 39) rotate(9.69158) scale(246.518)"
        >
          <stop stop-color="#F0F0F0" />
          <stop offset="1" stop-color="#D5DEE9" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3218_16607"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1414 309.5) rotate(160.242) scale(369.769)"
        >
          <stop stop-color="#F0F7FF" />
          <stop offset="1" stop-color="#CFD7E0" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_3218_16607"
          x1="111.5"
          y1="582.5"
          x2="-0.999987"
          y2="777"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DFEBF8" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
